module.exports = __webpack_public_path__ + "img/subscription1.3937cd4.png";